import { SerializableObject } from "../trackers/ITrack";

export const tryParse = (jsonString: string): SerializableObject | string => {
  let parsedJson;
  try {
    parsedJson = JSON.parse(jsonString);
    return parsedJson;
  } catch (e) {
    return jsonString;
  }
};
